<template>
    <button class="no-border back-button"
            @click="goBack">
        <IconArrowLeft class="icon" />
        <span class="text"><slot>Назад</slot></span>
    </button>
</template>

<script>
export default {
    name: 'BackButton',
    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push({
                    name: 'home',
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.back-button {
}
</style>
